// CHECK BELOW FOR ACTIONS IMPLEMENTATIONS
$(window).ready (function() {
  $("[data-action]").each(setupAction);
});

function setupAction() {
  var action = getAction(this);
  if (!action) { return }

  bindAction(this, action);
}

function bindAction(elt, action) {
  var tag = $(elt).prop("tagName");
  if (tag == 'A' || tag == 'DIV') {
    $(elt).click(action);
  }
  if (tag == 'INPUT' || tag == 'SELECT') {
    $(elt).on('change', action);
  }
}

// Actions should be registered in here
function getAction(elt) {
  var name = $(elt).attr('data-action');
  var action = undefined;
  switch (name) {
    case 'toggle-class':
      action = applyToggleClass;
      break;
    case 'stop-bubbling':
      action = stopBubbling;
      break;
    default:
      console.warn('undefined action', name);
  }
  return wrapBehaviours(name, action);
}

function wrapBehaviours(name, action){
  return function($event) {
    response = action.call(this, $event);
    if (response != false) {
      $(this).trigger(
        'action',
        { name: name, initialEvent: $event }
      )
    }
  }
}

// IMPLEMENTATIONS

function applyToggleClass($event) {
  $event.preventDefault();
  var target = $(this).attr('data-target-selector');
  var change = $(this).attr('data-value');
  $(target).toggleClass(change);

  history.replaceState(null, null, ' ');

  // Optional tracking
  if ($(this).attr('data-track') && window && window.analytics) {
    if ($(this).is(":checked")) {
      var location = 'no-' + $(this).attr('data-location');
    } else {
      var location = $(this).attr('data-location');
    }
    window.analytics.track(
      $(this).attr('data-event'),
      { "location": location }
    );
  }
}

function stopBubbling($event) {
  $event.stopPropagation();
}
